var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edudash-graph"},[_c('line-chart',{staticClass:"chart-box",attrs:{"chart-data":_vm.dataCollections,"options":_vm.graphOptions},on:{"canvas":_vm.handleCanvas,"chart":_vm.handleChart}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }